export var EventKey;
(function (EventKey) {
    EventKey["WATCH_SENT"] = "WATCH_SENT";
    EventKey["WATCH_RECEIVED"] = "WATCH_RECEIVED";
})(EventKey || (EventKey = {}));
